import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box, Grid, Typography, Icon } from '@blueprint/ui';
import { footerHeightChanged } from '../../actions/index';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';

const StyledLink = styled(Link)`
    color: white;

    &:hover {
        color: white;
    }
`;

const FooterTopGridContainer = styled(Grid)``;

const FooterBottomGridContainer = styled(Grid)``;

const TypographyWhite = styled(Typography)`
    color: white;

    &:hover {
        text-decoration: underline;
        color: white;
    }
`;

const TypographyDisclaimer = styled(Typography)`
    color: white;
`;

const TypographyBlack = styled(Typography)`
    &:hover {
        text-decoration: underline;
    }
`;

const FooterHeightLimited = styled.footer`
    /* max-height: 20vh; */
`;

const Styleda = styled.a`
    color: black;
    text-decoration: none;
    &:hover {
        color: black;
        text-decoration: none;
    }
`;

const StyledaWhite = styled.a`
    color: white;
    &:hover {
        color: white;
        text-decoration: underline;
    }
`;

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

const useStyles = makeStyles({
    hoverLink: {
        padding: '0.25em',
        '&:hover': { backgroundColor: '#EDEDED' },
        display: 'flex',
        flexDirection: 'row',
    },
});

const FooterComponent = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const footerRef = useRef();
    const [cursor, setCursor] = useState('default');
    const [helpDropdown, setHelpDropdown] = useState(false);
    const [tcDropdown, setTcDropdown] = useState(false);
    const classes = useStyles();
    const globalState = useSelector((state) => state);

    useEffect(() => {
        if (footerRef.current.clientHeight) {
            dispatch(footerHeightChanged(footerRef.current.clientHeight));
        }
    }, [dispatch]);

    const [windowWidth, windowHeight] = useWindowSize();

    useEffect(() => {
        dispatch(footerHeightChanged(footerRef.current.clientHeight));
    }, [windowWidth, windowHeight, dispatch]);

    // const { i18n } = useTranslation();
    // Enable this to change langauge
    // const englishHandler = (event) => {
    //     event.preventDefault();
    //     i18n.changeLanguage("en");
    // };

    // const hindiHandler = (event) => {
    //     event.preventDefault();
    //     i18n.changeLanguage("hi");
    // };

    const helpTabIndex = !helpDropdown ? '-1' : null;
    const tncTabIndex = !tcDropdown ? '-1' : null;

    return (
        <FooterHeightLimited style={{ position: 'absolute', bottom: '0px', width: '100%', left: '0px' }} id='main-footer' ref={footerRef}>
            <div style={{ backgroundColor: '#000000' }}>
                <FooterTopGridContainer
                    container
                    style={{ maxWidth: '1280px', margin: '0px auto 0px auto', padding: '0px 5vw 0px 5vw', position: 'relative' }}
                >
                    <Grid item xs={12} sm='auto'>
                        <Box
                            marginRight='2em'
                            padding='0.5em 0 0.5em 0'
                            onFocus={() => {
                                setHelpDropdown(true);
                            }}
                            onBlur={() => {
                                setHelpDropdown(false);
                            }}
                            onMouseOver={() => {
                                setCursor('pointer');
                                setHelpDropdown(true);
                            }}
                            onMouseLeave={() => {
                                setHelpDropdown(false);
                            }}
                            style={{ cursor: cursor }}
                        >
                            <TypographyWhite variant='body1' tabIndex='0' role='button' aria-expanded={helpDropdown}>
                                {t('footer.help')}
                            </TypographyWhite>
                            <Box
                                marginTop='-5em'
                                border='2px ridge gray'
                                style={
                                    helpDropdown
                                        ? { display: 'flex' }
                                        : {
                                              position: 'absolute',
                                              left: '-9999px',
                                          }
                                }
                                flexDirection='column'
                                position='absolute'
                                backgroundColor='white'
                                aria-hidden={!helpDropdown}
                                tabIndex={helpTabIndex}
                            >
                                <StyledLink
                                    target='_blank'
                                    to='help-video'
                                    aria-label={t('footer.helpVideoPaymentProcessing') + ' ' + t('footer.new_window')}
                                >
                                    <Box className={classes.hoverLink}>
                                        <Typography variant='body1' marginRight='0.5em'>
                                            {t('footer.helpVideoPaymentProcessing')} ({t('footer.new_window')})
                                        </Typography>
                                        <Icon name='NewWindow' alt={t('footer.new_window')} aria-hidden='true' marginTop='1px' size='14px' />
                                    </Box>
                                </StyledLink>

                                <StyledLink target='_blank' to='faq' aria-label={t('footer.faq') + ' ' + t('footer.new_window')}>
                                    <Box className={classes.hoverLink}>
                                        <Typography variant='body1' marginRight='0.5em'>
                                            {t('footer.faq')} ({t('footer.new_window')})
                                        </Typography>
                                        <Icon name='NewWindow' alt={t('footer.new_window')} aria-hidden='true' marginTop='1px' size='14px' />
                                    </Box>
                                </StyledLink>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm='auto'>
                        <Box
                            marginRight='2em'
                            padding='0.5em 0 0.5em 0'
                            onFocus={() => {
                                setTcDropdown(true);
                            }}
                            onBlur={() => {
                                setTcDropdown(false);
                            }}
                            onMouseOver={() => {
                                setCursor('pointer');
                                setTcDropdown(true);
                            }}
                            onMouseLeave={() => {
                                setTcDropdown(false);
                            }}
                            style={{ cursor: cursor }}
                        >
                            <TypographyWhite variant='body1' role='button' aria-expanded={tcDropdown}>
                                {t('footer.tnc')}
                            </TypographyWhite>

                            <Box
                                marginTop='-5em'
                                border='2px ridge gray'
                                paddingX={1}
                                style={
                                    tcDropdown
                                        ? { display: 'flex' }
                                        : {
                                              position: 'absolute',
                                              left: '-9999px',
                                          }
                                }
                                flexDirection='column'
                                position='absolute'
                                backgroundColor='white'
                                aria-hidden={!tcDropdown}
                                tabIndex={tncTabIndex}
                            >
                                <Styleda
                                    target='_blank'
                                    href='https://www.hsbc.com/terms-and-conditions?WT.ac=HGHQ_f8.1_On'
                                    aria-label={t('footer.hsbcTnc') + ' ' + t('footer.new_window')}
                                >
                                    <Box className={classes.hoverLink}>
                                        <Typography variant='body1' marginRight='0.5em'>
                                            {t('footer.hsbcTnc')} ({t('footer.new_window')})
                                        </Typography>
                                        <Icon name='NewWindow' alt={t('footer.new_window')} marginTop='1px' size='14px' aria-hidden='true' />
                                    </Box>
                                </Styleda>
                                <StyledLink
                                    target='_blank'
                                    to='/bsm-terms-and-conditions'
                                    aria-label={t('footer.hsbcBsmTnc') + ' ' + t('footer.new_window')}
                                >
                                    <Box className={classes.hoverLink}>
                                        <Typography variant='body1' marginRight='0.5em'>
                                            {t('footer.hsbcBsmTnc')} ({t('footer.new_window')})
                                        </Typography>
                                        <Icon name='NewWindow' alt={t('footer.new_window')} aria-hidden='true' marginTop='1px' size='14px' />
                                    </Box>
                                </StyledLink>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm='auto'>
                        <Box marginRight='2em' padding='0.5em 0 0.5em 0'>
                            <StyledLink target='_blank' to='/privacy-notice' aria-label={t('footer.privacy_notice') + ' ' + t('footer.new_window')}>
                                <TypographyWhite variant='body1'>
                                    {t('footer.privacy_notice')}{' '}
                                    <Icon name='NewWindow' alt={t('footer.new_window')} aria-hidden='true' size='14px' fill='white' />
                                </TypographyWhite>
                            </StyledLink>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm='auto'>
                        <Box marginRight='2em' padding='0.5em 0 0.5em 0'>
                            <TypographyWhite variant='body1'>
                                <StyledaWhite
                                    href='https://www.hsbc.com/accessibility'
                                    target='_blank'
                                    aria-label={t('footer.accessibility_policy') + ' ' + t('footer.new_window')}
                                >
                                    {t('footer.accessibility_policy')}{' '}
                                    <Icon name='NewWindow' alt={t('footer.new_window')} aria-hidden='true' size='14px' fill='white' />
                                </StyledaWhite>
                            </TypographyWhite>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm='auto'>
                        <Box marginRight='2em' padding='0.5em 0 0.5em 0'>
                            <StyledLink target='_blank' to='/cookie-notice' aria-label={t('footer.cookie_notice') + ' ' + t('footer.new_window')}>
                                <TypographyWhite variant='body1'>
                                    {t('footer.cookie_notice')}{' '}
                                    <Icon name='NewWindow' alt={t('footer.new_window')} aria-hidden='true' size='14px' fill='white' />
                                </TypographyWhite>
                            </StyledLink>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm='auto'>
                        <Box marginRight='2em' padding='0.5em 0 0.5em 0'>
                            <StyledLink
                                to={{
                                    pathname: '/contact-us',
                                    state: {
                                        previousUrl: location.pathname,
                                        wasLogged: globalState.beneDetails.details.isLogged,
                                    },
                                }}
                            >
                                <TypographyWhite variant='body1'>{t('footer.contact_us')}</TypographyWhite>
                            </StyledLink>
                        </Box>
                    </Grid>

                    <Grid item xs>
                        <Grid container direction='row-reverse'>
                            <Box padding='0.5em 0 0.5em 0'>
                                <Typography variant='body1' style={{ color: 'white' }}>
                                    &copy; HSBC Bank {new Date().getFullYear()}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </FooterTopGridContainer>
            </div>
            {/**          <div style={{ backgroundColor: '#000000' }}>
                <FooterBottomGridContainer container style={{ maxWidth: '1280px', margin: '0px auto 0px auto', padding: '0px 5vw 0px 5vw' }}>
                    <Grid item xs={12}>
                        <Box sm='auto' padding='0.5em 0 0.5em 0' maxWidth='768px' lineHeight='3px'>
                            <TypographyDisclaimer variant='body2'>{t('footer.disclaimer')}</TypographyDisclaimer>
                        </Box>
                    </Grid>
                </FooterBottomGridContainer>
            </div> */}
        </FooterHeightLimited>
    );
};

export default FooterComponent;
